import { ROI_SUMMARY } from "@/data/mock";

export default function PortalROI() {
  const r = ROI_SUMMARY;
  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow">// ROI</div>
        <h1 className="display-lg text-silver-50 mt-2">Every dollar, measured.</h1>
      </div>
      <div className="grid gap-6 md:grid-cols-3">
        <Big label="Revenue attributed" value={`$${(r.totalRevenue / 1000).toFixed(0)}k`} accent="blue" />
        <Big label="Total spend" value={`$${(r.totalSpend / 1000).toFixed(0)}k`} accent="silver" />
        <Big label="ROAS" value={`${r.roas.toFixed(2)}x`} accent="red" />
      </div>
      <div className="grid gap-6 md:grid-cols-3">
        <Small label="Leads" value={r.leads.toLocaleString()} />
        <Small label="Avg CPL" value={`$${r.avgCPL.toFixed(0)}`} />
        <Small label="Closed won" value={r.closedWon.toString()} />
      </div>
      <div className="panel p-8">
        <div className="eyebrow">// Attribution chart</div>
        <div className="mt-6 h-56 flex items-end gap-2">
          {[28, 42, 35, 51, 48, 63, 72, 68, 79, 84, 77, 92].map((h, i) => (
            <div key={i} className="flex-1 bg-gradient-to-t from-brand-blueDeep to-brand-cyan rounded-t-sm" style={{ height: `${h}%` }} />
          ))}
        </div>
        <div className="mt-3 font-mono text-xs text-silver-300 uppercase tracking-widest">// monthly attributed revenue · last 12</div>
      </div>
    </div>
  );
}

function Big({ label, value, accent }: { label: string; value: string; accent: "blue" | "red" | "silver" }) {
  const color = accent === "blue" ? "text-brand-blue" : accent === "red" ? "text-brand-red" : "text-silver-100";
  return (
    <div className="panel-hi p-8">
      <div className="eyebrow">// {label}</div>
      <div className={`mt-3 font-display font-extrabold text-5xl ${color}`}>{value}</div>
    </div>
  );
}
function Small({ label, value }: { label: string; value: string }) {
  return (
    <div className="panel p-6">
      <div className="eyebrow">// {label}</div>
      <div className="mt-2 font-display font-bold text-3xl text-silver-50">{value}</div>
    </div>
  );
}
